var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel panel-default table-of-contents margin-above" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-9" },
            [
              _c("autocomplete-tag", {
                attrs: {
                  "current-tags": _vm.currentTags,
                  "user-tags": _vm.userTagsFlat,
                },
                on: { "tag-update": _vm.updateTags },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help-block" }, [
                _vm._v(
                  "\n                    Add tags for these items, new tags (shown darker) will be created for you.\n                    Press enter to create and separate your tags.\n                "
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.type === "sddf"
          ? _c("div", { staticClass: "row" }, [
              _c("hr"),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-9" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      domProps: { value: _vm.selectedWorkGroup },
                      on: { change: _vm.changeSelectedWorkgroup },
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                            Select a Workgroup\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        JSON.parse(_vm.userWorkgroups),
                        function (workgroup) {
                          return _c(
                            "option",
                            {
                              key: workgroup.id,
                              domProps: { value: workgroup.id },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(workgroup.name) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "help-block" }, [
                    _vm._v(
                      "\n                        Select a workgroup for these items.\n                    "
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", [_vm._v("Options")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-3" }, [
      _c("strong", { staticClass: "margin-left" }, [_vm._v("Tags")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-3" }, [
      _c("strong", { staticClass: "margin-left" }, [_vm._v("Workgroup")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }